import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationPTBR from "./locales/pt-br.json";

const resources = {
  pt: {
    translation: translationPTBR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "pt", //default language
  fallbackLng: "pt",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
